import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import fc50HzMl2pir2_5cm from "./components/fc-50Hz-mL-2pi-r-2.5cm";
import fc50HzMl2pir10cm from "./components/fc-50Hz-mL-2pi-r-10cm";
import fc1000HzMl2pir2_5cm from "./components/fc-1000Hz-mL-2pi-r-2.5cm";
import fc1000HzMl2pir10cm from "./components/fc-1000Hz-mL-2pi-r-10cm";

import fc50HzMlpir2_5cm from "./components/fc-50Hz-mL-pi-r-2.5cm";
import fc50HzMlpir10cm from "./components/fc-50Hz-mL-pi-r-10cm";
import fc1000HzMlpir2_5cm from "./components/fc-1000Hz-mL-pi-r-2.5cm";
import fc1000HzMlpir10cm from "./components/fc-1000Hz-mL-pi-r-10cm";

import fc50HzMlpiover2r2_5cm from "./components/fc-50Hz-mL-piover2-r-2.5cm";
import fc50HzMlpiover2r10cm from "./components/fc-50Hz-mL-piover2-r-10cm";
import fc1000HzMlpiover2r2_5cm from "./components/fc-1000Hz-mL-piover2-r-2.5cm";
import fc1000HzMlpiover2r10cm from "./components/fc-1000Hz-mL-piover2-r-10cm";

import fc50HzMlpiover4r2_5cm from "./components/fc-50Hz-mL-piover4-r-2.5cm";
import fc50HzMlpiover4r10cm from "./components/fc-50Hz-mL-piover4-r-10cm";
import fc1000HzMlpiover4r2_5cm from "./components/fc-1000Hz-mL-piover4-r-2.5cm";
import fc1000HzMlpiover4r10cm from "./components/fc-1000Hz-mL-piover4-r-10cm";

const principle: Slide = {
  description:
    "The input impedance of exponential horns is calculated and plotted together with the horn profile for two cut-off frequencies (50 Hz or 1000 Hz), four values of the product mL (π/4, π/2, π, or 2π), and two input radius (2.5 cm or 10 cm). The input for a finite length of the horn is compared to the infinite case and it is seen that some choices are more realistic and closer to the ideal case than others!",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: {
            label: "Cut-off frequency",
          },
          items: [{ name: "50 Hz" }, { name: "1000 Hz" }],
        },
        {
          type: "dropdown",
          options: {
            label: "mL",
          },
          items: [{ name: "π/4" }, { name: "π/2" }, { name: "π" }, { name: "2π" }],
        },
        {
          type: "dropdown",
          options: {
            label: "Input radius",
          },
          items: [{ name: "2.5 cm" }, { name: "10 cm" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [
        [
          [[], []],
          [[], []],
          [[], []],
          [[], []],
        ],
        [
          [[], []],
          [[], []],
          [[], []],
          [[], []],
        ],
      ],
      components: [
        [
          [fc50HzMlpiover4r2_5cm, fc50HzMlpiover4r10cm],
          [fc50HzMlpiover2r2_5cm, fc50HzMlpiover2r10cm],
          [fc50HzMlpir2_5cm, fc50HzMlpir10cm],
          [fc50HzMl2pir2_5cm, fc50HzMl2pir10cm],
        ],
        [
          [fc1000HzMlpiover4r2_5cm, fc1000HzMlpiover4r10cm],
          [fc1000HzMlpiover2r2_5cm, fc1000HzMlpiover2r10cm],
          [fc1000HzMlpir2_5cm, fc1000HzMlpir10cm],
          [fc1000HzMl2pir2_5cm, fc1000HzMl2pir10cm],
        ],
      ],
    },
  },
};

export default principle;
